import ActionHistoryValue from "@/api/Main/dataSource/api/projects/task/i-service/models/action-history/response/ActionHistoryValue";
import UserTaskItem from "@/api/Main/dataSource/api/projects/task/i-service/models/task/response/UserTaskItem";
import { ActionEnum } from "../enums";

/**
 * * Модель истории
 */
export class TaskHistoryModel {
  /**
   * id записи в истории
   */
  Id!: string;
  /**
   * id записи в истории
   */
  Performer!: UserTaskItem;
  /**
   * id записи в истории
   */
  Value: ActionHistoryValue;
  /**
   * id записи в истории
   */
  ActionType!: ActionEnum;
  /**
   * id записи в истории
   */
  DateCreated!: Date;
  constructor(obj?: Partial<TaskHistoryModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
